<template>
    <div style="width: 1100px;" class="container" ref="container" @mousedown="handleMousedown" @mousemove="handleMousemove"
        @mouseup="handleMouseUp" @mouseleave="handleMouseleave">
        <div class="item" v-for="(item, index) in list" :key="index">
            <a href="javascript:;">
                <img :src="item.thumbnail_url" alt="esg" :data-url="item.article_url">
                <p class="txt" :data-url="item.article_url">{{ item.title }}</p>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            flag: false, //鼠标按下
            downX: 0, //鼠标点击的x下标
            scrollLeft: 0, //当前元素滚动条的偏移量
        }
    },
    methods: {
        handleMousedown(e) {
            e.preventDefault()
            console.log(20);
            this.flag = true
            this.downX = e.clientX
            this.scrollLeft = this.$refs.container.scrollLeft
        },
        handleMousemove(e) {
            if (!this.flag) return
            let moveX = e.clientX
            let scrollx = moveX - this.downX
            this.$refs.container.scrollLeft = this.scrollLeft - scrollx
        },
        handleMouseUp(e) {
            this.flag = false
            if (Math.abs(e.clientX - this.downX) >= 0 && Math.abs(e.clientX - this.downX) < 2) {
                // 触发点击
                location.href = e.target.dataset.url
            }
        },
        handleMouseleave(e) {
            this.flag = false
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    min-width: 1100px;
    overflow: hidden;
    display: flex;
    margin: 20px auto;

    .item {
        width: 286px;
        flex-shrink: 0;

        a {
            text-decoration: none;
            color: #000;
        }

        img {
            width: 100%;
            height: 160px;
        }

        .txt {
            width: 100%;
            word-wrap: break-word;
            font-size: 16px;
            margin-top: 10px;
            line-height: 22px;
            text-align: justify;
        }

        &:not(:last-child) {
            margin-right: 30px;
        }
    }
}
</style>
